module.exports = require('./lib/addons');